import { getScriptById } from '@/services/script-service';
import {
  getAgentsAvaibleChatQueue,
  getQueues,
  getQueuesByOrg,
} from '@/services/chat-service';
import { SET_CHAT_QUEUES } from '@/store/mutation-types';
import { outhersAgents } from '@/shared/utils/helpers';

const actions = {
  clearChatQueue({ commit }) {
    commit(SET_CHAT_QUEUES, []);
  },

  getQueuesChat({ commit, dispatch }) {
    dispatch('clearChatQueue');

    return getQueues().then((queues) => {
      commit(SET_CHAT_QUEUES, queues);
    });
  },

  getQueuesChatByOrg({ commit, dispatch }, org) {
    dispatch('clearChatQueue');

    return getQueuesByOrg(org).then((queues) => {
      commit(SET_CHAT_QUEUES, queues);
    });
  },

  getScriptChatQueue({ dispatch }, { scriptId, protocol }) {
    getScriptById(scriptId)
      .then((script) => {
        dispatch('jobs/setScriptJob', { script, protocol }, { root: true });
      })
      .catch(console.error);
  },

  getAgentsQueue({ commit, dispatch }, { chatQueue, agentId }) {
    dispatch('clearChatQueue');
    const filterAgents = outhersAgents(agentId);

    getAgentsAvaibleChatQueue(chatQueue, agentId)
      .then(filterAgents)
      .then((agents) => {
        commit(SET_CHAT_QUEUES, agents);
      });
  },
};

export default actions;
